import { render } from "./LEA_CategoriesWidget.vue?vue&type=template&id=cd29484e&scoped=true"
import script from "./LEA_CategoriesWidget.vue?vue&type=script&lang=js"
export * from "./LEA_CategoriesWidget.vue?vue&type=script&lang=js"

import "./LEA_CategoriesWidget.vue?vue&type=style&index=0&id=cd29484e&scoped=true&lang=css"

import exportComponent from "/Users/admin/dev/claire/web/orca-analytics.web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd29484e"]])

export default __exports__